import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import httphelper from "./assets/unit/HttpHelper";
import VueLazyLoad  from 'vue3-lazyload'

const app = createApp(App);
app.config.globalProperties.$httphelper = httphelper;
app.use(router).use(VueLazyLoad).mount("#app");
